import { saveEntities } from '../factories'
import * as actions from './actions'

export const find = [
  //
  actions.find,
  saveEntities(),
]

export const get = [
  //
  actions.get,
  saveEntities(),
]

export const save = [
  //
  actions.save,
  saveEntities(),
]
